export const splitResidentNumber = (value?: string | null) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 13);

  return {
    front: digits.slice(0, 6),
    back: digits.slice(6, 13)
  };
};

export const buildResidentNumber = (front: string, back: string) => {
  const normalizedFront = front.replace(/\D/g, '').slice(0, 6);
  const normalizedBack = back.replace(/\D/g, '').slice(0, 7);

  if (normalizedFront.length !== 6 || normalizedBack.length !== 7) {
    return '';
  }

  return `${normalizedFront}-${normalizedBack}`;
};

export const sanitizeResidentNumberPart = (value: string, maxLength: number) =>
  value.replace(/\D/g, '').slice(0, maxLength);
